<section class="min-h-[85vh] relative max-w-[1320px] mx-auto px-6 lg:px-10 pt-8 pb-10 md:pt-10 md:pb-8 relative z-10">
  <!-- Header -->
  <div class="mb-8 text-left">
    <h1 class="font-display font-black text-[36px] md:text-[44px] text-white tracking-wide leading-tight mb-2">
      Swap
    </h1>
    <p class="text-text-muted text-[15px] mb-4">Trade tokens in an instant with the best prices.</p>
    <div class="mt-6 p-4 rounded-xl bg-gold/10 border border-gold/30 flex items-start gap-3">
      <svg class="w-5 h-5 text-gold flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <p class="text-white text-[13.5px] leading-relaxed">
        <span class="font-bold text-gold">Important Note:</span> Before entering a liquidity pool on DEX you can swap half of your WETH for USDC and USDT or vice versa so that you can participate in the liquidity pools and earn fees daily. Please remember to have ETH or BNB in your wallet to cover the gas fees
      </p>
    </div>
  </div>

  <div class="grid grid-cols-1 min-[1200px]:grid-cols-12 gap-6 w-full">
    <!-- LEFT COLUMN -->
    <div class="w-full min-[800px]:w-[70%] min-[800px]:mx-auto min-[1200px]:w-full min-[1200px]:mx-0 min-[1200px]:col-span-5 flex flex-col gap-6">

      <!-- SWAP CARD -->
      <div
        class="card p-5 relative overflow-hidden rounded-[20px] bg-[#0c0c0c]/90 border border-white/[0.08] backdrop-blur-xl w-full">
        <!-- Swap Header -->
        <div class="flex items-end justify-end mb-5">
          <!-- <button
            class="p-2 text-text-dim hover:text-white transition-colors bg-white/[0.03] rounded-lg border border-white/[0.05]">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </button> -->

          <div class="flex items-center gap-2 relative">
            <button (click)="state.showSlippageDropdown.set(!state.showSlippageDropdown())"
              class="flex items-center gap-1 text-[12px] font-bold text-white bg-white/[0.05] border border-white/[0.08] rounded-lg px-2.5 py-1 hover:bg-white/[0.1] transition-colors">
              {{ state.slippageTolerance() }}%
              <svg class="w-3 h-3 text-text-dim" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
            </button>

            <!-- Slippage Tolerance Dropdown -->
            @if (state.showSlippageDropdown()) {
            <div
              class="absolute right-0 top-10 w-44 bg-[#0a0a0a]/95 backdrop-blur-2xl border border-border-primary rounded-xl p-3.5 shadow-2xl z-20 animate-fade-in">
              <span class="text-[10px] text-text-dim font-bold block mb-2 uppercase tracking-wider">Slippage
                Tolerance</span>
              <div class="grid grid-cols-3 gap-1.5">
                @for (val of [0.1, 0.5, 1.0]; track val) {
                <button type="button" (click)="state.setSlippage(val)"
                  class="text-[11px] font-bold py-2 border rounded-lg text-white transition-all duration-200"
                  [class.border-gold]="state.slippageTolerance() === val"
                  [class.bg-gold/15]="state.slippageTolerance() === val"
                  [class.border-border-primary]="state.slippageTolerance() !== val"
                  [class.bg-white/[0.02]]="state.slippageTolerance() !== val"
                  [class.hover:bg-white/[0.04]]="state.slippageTolerance() !== val">{{ val }}%</button>
                }
              </div>
            </div>
            }
          </div>
        </div>

        <!-- INPUT FORM: FROM -->
        <div
          class="bg-[#050505] border border-white/[0.08] focus-within:border-gold/25 rounded-xl p-4 transition-all duration-200">
          <div class="flex items-center justify-between text-[12px] font-semibold text-text-dim mb-1.5">
            <span>You pay</span>
            <div class="flex items-center gap-1.5 text-white">
              <span class="text-text-dim text-[11px]">Balance: {{ state.isWalletConnected() ? (state.isBalancesLoading() ? 'Loading...' : state.getFormattedBalance(state.fromToken().address)) : '--' }}</span>
              <button (click)="state.setMax('from')"
                class="text-[10px] text-gold border border-gold/30 rounded px-1.5 py-0.5 hover:bg-gold/10">MAX</button>
            </div>
          </div>
          <div class="flex items-center justify-between gap-3">
            <button type="button" (click)="state.openTokenModal('from')"
              class="border border-white/[0.1] bg-[#0f0f0f] rounded-xl px-3.5 py-2 flex items-center gap-2 hover:bg-white/[0.03] transition-colors shrink-0 shadow-sm min-w-[120px]">
              <span
                class="w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold text-white shadow-md bg-[#F3BA2F]"
                [style.background]="state.fromToken().color">
                <img *ngIf="state.fromToken().logoUrl" [src]="state.fromToken().logoUrl" class="w-full h-full rounded-full object-cover">
                <ng-container *ngIf="!state.fromToken().logoUrl">{{ state.fromToken().symbol.charAt(0) }}</ng-container>
              </span>
              <div class="flex flex-col items-start">
                <span class="text-[13.5px] font-extrabold text-white tracking-wide leading-tight">{{
                  state.fromToken().symbol }}</span>
                <span class="text-[10px] text-text-dim font-medium leading-none">{{ state.fromToken().name }}</span>
              </div>
              <svg class="w-3 h-3 text-text-muted ml-auto" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
              </svg>
            </button>
            <div class="text-right flex-1 min-w-0">
              <input type="text" placeholder="0" [value]="state.fromAmount() ? state.fromAmount() : ''"
                (input)="state.onFromAmountChange($event)" class="swap-input text-[28px] font-bold text-right w-full" />
            </div>
          </div>
          <div class="text-right text-[12px] text-text-dim mt-2 leading-none">
            ~ ${{(parseFloat(state.fromAmount() || '0') * state.fromToken().rate).toLocaleString('en-US',
            {minimumFractionDigits: 2, maximumFractionDigits: 2})}}
          </div>
        </div>

        <!-- FLIP ASSET DIRECTION SWITCH -->
        <div class="flex justify-center -my-3.5 relative z-10">
          <button type="button" (click)="state.swapTokensDirection()"
            class="swap-direction-btn bg-[#0c0c0c] border-4 border-[#0c0c0c]">
            <svg class="w-4 h-4 text-gold" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5" />
            </svg>
          </button>
        </div>

        <!-- INPUT FORM: TO -->
        <div
          class="bg-[#050505] border border-white/[0.08] focus-within:border-gold/25 rounded-xl p-4 transition-all duration-200 mt-1">
          <div class="flex items-center justify-between text-[12px] font-semibold text-text-dim mb-1.5">
            <span>You receive</span>
            <div class="flex items-center gap-1.5 text-white">
              <span class="text-text-dim text-[11px]">Balance: {{ state.toToken() && state.isWalletConnected() ? (state.isBalancesLoading() ? 'Loading...' : state.getFormattedBalance(state.toToken()!.address)) : '--' }}</span>
            </div>
          </div>
          <div class="flex items-center justify-between gap-3">
            @if (state.toToken()) {
            <button type="button" (click)="state.openTokenModal('to')"
              class="border border-white/[0.1] bg-[#0f0f0f] rounded-xl px-3.5 py-2 flex items-center gap-2 hover:bg-white/[0.03] transition-colors shrink-0 shadow-sm min-w-[120px]">
              <span
                class="w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold text-white shadow-md bg-gold"
                [style.background]="state.toToken()!.color">
                <img *ngIf="state.toToken()!.logoUrl" [src]="state.toToken()!.logoUrl" class="w-full h-full rounded-full object-cover">
                <ng-container *ngIf="!state.toToken()!.logoUrl">{{ state.toToken()!.symbol.charAt(0) }}</ng-container>
              </span>
              <div class="flex flex-col items-start">
                <span class="text-[13.5px] font-extrabold text-white tracking-wide leading-tight">{{
                  state.toToken()!.symbol }}</span>
                <span class="text-[10px] text-text-dim font-medium leading-none">{{ state.toToken()!.name }}</span>
              </div>
              <svg class="w-3 h-3 text-text-muted ml-auto" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
              </svg>
            </button>
            } @else {
            <button type="button" (click)="state.openTokenModal('to')"
              class="bg-gold hover:bg-gold/90 text-black rounded-xl px-3.5 py-2 flex items-center gap-2 transition-colors shrink-0 font-bold shadow-md min-w-[120px]">
              <span class="text-[13.5px] tracking-wide mx-auto">Select</span>
              <svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
              </svg>
            </button>
            }
            <div class="text-right flex-1 min-w-0">
              <input type="text" placeholder="0" [value]="state.toAmount() ? state.toAmount() : ''"
                (input)="state.onToAmountChange($event)" class="swap-input text-[28px] font-bold text-right w-full" />
            </div>
          </div>
          <div class="text-right text-[12px] text-text-dim mt-2 leading-none flex items-center justify-end gap-1">
            @if(state.toAmount()) {
            <span>~ ${{(parseFloat(state.toAmount() || '0') * (state.toToken()?.rate || 0)).toLocaleString('en-US',
              {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
            } @else {
            <span>~ $0.00</span>
            }
          </div>
        </div>

        <!-- Details (Rate, Price Impact, Network Fee) -->
        <div class="mt-5 flex flex-col gap-3 px-1 text-[12px] font-semibold text-text-muted">
          @if(state.isFetchingQuote()) {
             <div class="text-center text-gold py-2">Fetching best route...</div>
          } @else {
            <div class="flex justify-between items-center">
              <span>Rate</span>
              <span class="text-white flex items-center gap-1">{{ state.exchangeRate() }}</span>
            </div>

            <div class="flex justify-between items-center">
              <span class="flex items-center gap-1">Network Fee</span>
              <span class="text-white">~ ${{ state.networkFeeUSD() }}</span>
            </div>
            <div class="flex justify-between items-center">
              <span class="flex items-center gap-1">Minimum Received</span>
              <span class="text-white">{{ state.minimumReceived() }} {{state.toToken()?.symbol}}</span>
            </div>
          }
        </div>

        <!-- CONNECT OR SWAP MAIN TRIGGER -->
        <div class="mt-6">
          @if (state.isWalletConnected()) {
          <button type="button" (click)="state.executeSwap()" 
            [disabled]="!state.getSwapValidationState().isValid || state.isSwapping()"
            [class.opacity-50]="!state.getSwapValidationState().isValid || state.isSwapping()"
            [class.cursor-not-allowed]="!state.getSwapValidationState().isValid || state.isSwapping()"
            class="btn-gold w-full py-3.5 rounded-xl text-[14.5px] font-extrabold tracking-widest uppercase transition-all duration-200 flex items-center justify-center gap-2">
            @if(state.isSwapping()) {
              <svg class="animate-spin h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span>Swapping...</span>
            } @else {
              <span>{{ state.getSwapValidationState().message }}</span>
            }
          </button>
          } @else {
          <button type="button" (click)="state.openConnectModal()"
            class="btn-gold w-full py-3.5 rounded-xl text-[14.5px] font-extrabold tracking-widest uppercase shadow-[0_0_20px_rgba(245,183,59,0.2)]">
            Connect Wallet
          </button>
          }
        </div>
      </div>

      <!-- BEST ROUTE CARD -->
      <div class="card p-5 rounded-[20px] bg-[#0c0c0c]/90 border border-white/[0.08] backdrop-blur-xl w-full">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-[14px] font-bold text-white flex items-center gap-1.5">Best Route <svg
              class="w-3.5 h-3.5 text-text-dim" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg></h3>
          <a [href]="getExplorerUrl(state.currentSwapRoute()?.targetAddress)" target="_blank" class="text-[12px] font-bold text-gold flex items-center gap-1 hover:underline">View on Explorer
            <svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg></a>
        </div>

        <!-- Route Visualization -->
        <div class="flex items-center gap-2 py-3 border-y border-white/[0.05] mb-4">
          <!-- Token 1 -->
          <div class="flex items-center gap-1.5 p-1 pr-3 rounded-full bg-white/[0.03] border border-white/[0.05]">
            <span class="w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold text-white"
              [style.background]="state.fromToken().color">
              <img *ngIf="state.fromToken().logoUrl" [src]="state.fromToken().logoUrl" class="w-full h-full rounded-full object-cover">
              <ng-container *ngIf="!state.fromToken().logoUrl">{{ state.fromToken().symbol.charAt(0) }}</ng-container>
            </span>
            <span class="text-[12px] font-bold text-white">{{state.fromToken().symbol}}</span>
          </div>

          <div class="flex-1 border-t border-dashed border-white/[0.15]"></div>

          @if(state.currentSwapRoute()?.type === 'AGGREGATOR') {
          <!-- Third Party Node -->
          <div class="flex items-center gap-1.5 p-1 pr-3 rounded-full bg-white/[0.03] border border-white/[0.05]">
            <span class="w-6 h-6 rounded-full flex items-center justify-center text-[10px] bg-white text-black font-bold">⚡</span>
            <span class="text-[12px] font-bold text-white">Route</span>
          </div>
          <div class="flex-1 border-t border-dashed border-white/[0.15]"></div>
          } @else if(state.currentSwapRoute()?.type === 'DEX') {
          <!-- DEX Node -->
          <div class="flex items-center gap-1.5 p-1 pr-3 rounded-full bg-white/[0.03] border border-white/[0.05]">
            <span class="w-6 h-6 rounded-full flex items-center justify-center text-[10px] bg-[#d6a843] text-white font-bold">D</span>
            <span class="text-[12px] font-bold text-white">Route</span>
          </div>
          <div class="flex-1 border-t border-dashed border-white/[0.15]"></div>
          }

          <!-- Token 3 -->
          @if(state.toToken()) {
          <div class="flex items-center gap-1.5 p-1 pr-3 rounded-full bg-white/[0.03] border border-white/[0.05]">
            <span class="w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold text-white"
              [style.background]="state.toToken()!.color">
              <img *ngIf="state.toToken()!.logoUrl" [src]="state.toToken()!.logoUrl" class="w-full h-full rounded-full object-cover">
              <ng-container *ngIf="!state.toToken()!.logoUrl">{{ state.toToken()!.symbol.charAt(0) }}</ng-container>
            </span>
            <span class="text-[12px] font-bold text-white">{{state.toToken()!.symbol}}</span>
          </div>
          } @else {
          <div class="flex items-center gap-1.5 p-1 pr-3 rounded-full bg-white/[0.03] border border-white/[0.05]">
            <span
              class="w-6 h-6 rounded-full flex items-center justify-center text-[10px] bg-[#222] text-white">?</span>
            <span class="text-[12px] font-bold text-white">---</span>
          </div>
          }
        </div>

        <div class="flex flex-col gap-2.5 text-[12px] font-semibold text-text-muted">
          <div class="flex justify-between">
            <span>Best Price</span>
            <span class="text-white">{{state.toAmount() || '0'}} {{state.toToken()?.symbol}}</span>
          </div>

          <div class="flex justify-between">
            <span>Estimated Network Fee</span>
            <span class="text-white">~ ${{ state.networkFeeUSD() }}</span>
          </div>
        </div>
      </div>

    </div>

    <!-- RIGHT COLUMN -->
    <div class="w-full min-[800px]:w-[70%] min-[800px]:mx-auto min-[1200px]:w-full min-[1200px]:mx-0 min-[1200px]:col-span-7 flex flex-col gap-6">

      <!-- SELECT A TOKEN CARD -->
      <div
        class="card p-5 rounded-[20px] bg-[#0c0c0c]/90 border border-white/[0.08] backdrop-blur-xl w-full flex flex-col h-[400px]">
        <h3 class="text-[15px] font-bold text-white mb-4">Select a token</h3>

        <!-- Search bar -->
        <div class="relative mb-4">
          <svg class="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-text-dim" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input type="text" placeholder="Search by name or paste address"
            class="w-full bg-[#050505] border border-white/[0.08] rounded-xl py-2.5 pl-10 pr-4 text-[13px] text-white focus:border-gold/30 outline-none"
            (input)="state.tokenSearchQuery.set($event.target.value)" />
        </div>

        <!-- Filters -->
        <div class="flex flex-wrap gap-2 mb-4">
          <button (click)="setFilterTab('favorites')"
            [class]="activeFilterTab === 'favorites' ? 'flex items-center gap-1.5 px-3 py-1.5 rounded-xl border border-gold bg-gold/10 text-[12px] font-bold text-gold' : 'flex items-center gap-1.5 px-3 py-1.5 rounded-xl border border-white/[0.08] bg-white/[0.03] text-[12px] font-bold text-text-muted hover:text-white transition-colors'">
            <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
            </svg> Favorites
          </button>
          <button (click)="setFilterTab('all')"
            [class]="activeFilterTab === 'all' ? 'px-3 py-1.5 rounded-xl border border-gold bg-gold/10 text-[12px] font-bold text-gold' : 'px-3 py-1.5 rounded-xl border border-white/[0.08] bg-white/[0.03] text-[12px] font-bold text-text-muted hover:text-white transition-colors'">All
            Tokens</button>
        </div>

        <!-- Token List -->
        <div class="flex-1 overflow-y-auto pr-2 flex flex-col gap-1">
          @for(token of state.filteredTokens(); track token.symbol) {
          <button (click)="state.selectToken(token)"
            class="flex items-center justify-between p-2.5 rounded-xl hover:bg-white/[0.04] transition-colors w-full text-left group">
            <div class="flex items-center gap-3">
              <span
                class="w-8 h-8 rounded-full flex items-center justify-center text-[12px] font-bold text-white shadow-md"
                [style.background]="token.color">
                <img *ngIf="token.logoUrl" [src]="token.logoUrl" class="w-full h-full rounded-full object-cover">
                <ng-container *ngIf="!token.logoUrl">{{ token.symbol.charAt(0) }}</ng-container>
              </span>
              <div>
                <div class="text-[13px] font-bold text-white">{{token.symbol}}</div>
                <div class="text-[11px] text-text-dim">{{token.name}}</div>
              </div>
            </div>
            <div class="flex items-center gap-4">
              <div class="text-right">
                <div class="text-[13px] font-bold text-white">${{token.rate.toLocaleString('en-US',
                  {minimumFractionDigits: 2})}}</div>
                <div class="text-[11px] font-bold" [class.text-[#20d489]]="token.change > 0"
                  [class.text-red-500]="token.change <= 0">{{token.change > 0 ? '+' : ''}}{{token.change}}%</div>
              </div>
              <button (click)="toggleFavorite($event, token)" 
                 class="transition-colors"
                 [ngClass]="state.favoriteTokens().includes(token.symbol) ? 'text-gold opacity-100' : 'text-text-dim hover:text-gold opacity-0 group-hover:opacity-100'">
                <svg class="w-4 h-4" [attr.fill]="state.favoriteTokens().includes(token.symbol) ? 'currentColor' : 'none'" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                </svg>
              </button>
            </div>
          </button>
          }
        </div>

        <div class="text-center mt-3 pt-3 border-t border-white/[0.05]">
          <a [routerLink]="['/explore']"
            class="text-[12px] font-bold text-gold hover:underline flex items-center justify-center gap-1">View all
            tokens <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg></a>
        </div>
      </div>

      <!-- MARKET OVERVIEW CARD -->
      <div
        class="card p-5.5 rounded-[20px] bg-[#0c0c0c]/90 border border-white/[0.08] backdrop-blur-xl w-full overflow-hidden">
        <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-5">
          <h3 class="font-display font-black text-[15.5px] uppercase tracking-wider text-white">Market Overview</h3>
          <div class="flex flex-wrap items-center bg-white/[0.03] border border-white/[0.08] rounded-lg p-0.5">
            @for (tf of timeframes; track tf) {
            <button (click)="setTimeframe(tf)" class="px-2.5 py-1 text-[11px] font-bold transition-all rounded-md"
              [class.bg-white]="activeChartTimeframe === tf" [class.text-black]="activeChartTimeframe === tf"
              [class.text-text-muted]="activeChartTimeframe !== tf"
              [class.hover:text-white]="activeChartTimeframe !== tf">{{tf}}</button>
            }
          </div>
        </div>

        <div class="flex flex-wrap items-center gap-x-3 gap-y-2 mb-6">
          <div class="flex items-center">
            <span
              class="w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold text-white z-10 border border-[#050505] shadow-sm"
              [style.background]="state.fromToken().color">
              <img *ngIf="state.fromToken().logoUrl" [src]="state.fromToken().logoUrl" class="w-full h-full rounded-full object-cover">
              <ng-container *ngIf="!state.fromToken().logoUrl">{{ state.fromToken().symbol.charAt(0) }}</ng-container>
            </span>
            @if(state.toToken()) {
            <span
              class="w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold text-white -ml-2 border border-[#050505] shadow-sm"
              [style.background]="state.toToken()!.color">
              <img *ngIf="state.toToken()!.logoUrl" [src]="state.toToken()!.logoUrl" class="w-full h-full rounded-full object-cover">
              <ng-container *ngIf="!state.toToken()!.logoUrl">{{ state.toToken()!.symbol.charAt(0) }}</ng-container>
            </span>
            }
          </div>
          <div class="flex items-center gap-1">
            <span class="text-[13px] font-black text-white">{{state.fromToken().symbol}} / USD</span>
          </div>
          <div class="text-[20px] font-display font-black text-white sm:ml-2">
            ${{state.fromToken().rate.toLocaleString('en-US', {minimumFractionDigits: 2})}}</div>
          <div class="text-[12px] font-bold" [class.text-[#20d489]]="state.fromToken().change > 0" [class.text-red-500]="state.fromToken().change <= 0">
            {{state.fromToken().change > 0 ? '+' : ''}}{{state.fromToken().change}}%
          </div>
        </div>

        <!-- ECHARTS CONTAINER -->
        <div #chartContainer class="w-full h-[280px]"></div>
      </div>

    </div>
  </div>

  <!-- Features Row -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-12 py-10 border-t border-white/[0.04]">
    <!-- Feature 1 -->
    <div class="flex items-start gap-4">
      <div
        class="w-12 h-12 rounded-[16px] bg-gradient-to-br from-gold/10 to-transparent border border-gold/20 flex items-center justify-center text-gold shadow-[0_0_15px_rgba(245,183,59,0.1)] flex-shrink-0">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
        </svg>
      </div>
      <div>
        <h4 class="text-[14.5px] font-bold text-white mb-1.5">Best Prices</h4>
        <p class="text-[12px] text-text-muted leading-relaxed">Smart routing ensures you get the best rates across DEXs.
        </p>
      </div>
    </div>
    <!-- Feature 2 -->
    <div class="flex items-start gap-4">
      <div
        class="w-12 h-12 rounded-[16px] bg-gradient-to-br from-gold/10 to-transparent border border-gold/20 flex items-center justify-center text-gold shadow-[0_0_15px_rgba(245,183,59,0.1)] flex-shrink-0">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      </div>
      <div>
        <h4 class="text-[14.5px] font-bold text-white mb-1.5">Secure & Non-Custodial</h4>
        <p class="text-[12px] text-text-muted leading-relaxed">You remain in control of your funds at all times.</p>
      </div>
    </div>
    <!-- Feature 3 -->
    <div class="flex items-start gap-4">
      <div
        class="w-12 h-12 rounded-[16px] bg-gradient-to-br from-gold/10 to-transparent border border-gold/20 flex items-center justify-center text-gold shadow-[0_0_15px_rgba(245,183,59,0.1)] flex-shrink-0">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <div>
        <h4 class="text-[14.5px] font-bold text-white mb-1.5">Low Fees</h4>
        <p class="text-[12px] text-text-muted leading-relaxed">Optimized routes with minimal slippage.</p>
      </div>
    </div>
    <!-- Feature 4 -->
    <div class="flex items-start gap-4">
      <div
        class="w-12 h-12 rounded-[16px] bg-gradient-to-br from-gold/10 to-transparent border border-gold/20 flex items-center justify-center text-gold shadow-[0_0_15px_rgba(245,183,59,0.1)] flex-shrink-0">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      </div>
      <div>
        <h4 class="text-[14.5px] font-bold text-white mb-1.5">Fast Transactions</h4>
        <p class="text-[12px] text-text-muted leading-relaxed">Execute swaps in seconds with reliable speed.</p>
      </div>
    </div>
  </div>
</section>